import {
  AfterViewInit,
  booleanAttribute,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {Utils} from '@astek/utils';
import {timer} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
  selector: 'xp-comment',
  templateUrl: './comment.component.html',
  styleUrl: './comment.component.scss',
})
export class CommentComponent implements AfterViewInit {

  @Input()
  public commentText: string = '';

  @Input({transform: booleanAttribute})
  @HostBinding('class.action-on-right')
  public actionOnRight: boolean = true;

  @Input({transform: booleanAttribute})
  public focusOnOpen: boolean = false;

  @Input({transform: booleanAttribute})
  public readonly: boolean = false;

  @Output()
  public commentUpdated: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  public deleteCommentRequested: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  public editFinished: EventEmitter<void> = new EventEmitter<void>();

  public readonly formGroup = this._formBuilder.group({
    comment: new FormControl<string | null>(null),
  });

  @ViewChild('comment')
  public commentRef!: ElementRef<HTMLElement>;

  constructor(
    private readonly _formBuilder: FormBuilder,
  ) {
    this.formGroup.controls.comment.valueChanges.pipe(
      takeUntilDestroyed(),
    ).subscribe((value) => {
      this.commentUpdated.emit(Utils.valueOr(value, ''));
    });
  }

  public ngAfterViewInit(): void {
    this.formGroup.controls.comment.setValue(this.commentText);
    if (this.focusOnOpen) {
      timer(200).subscribe(() => {
        const inputs: NodeListOf<HTMLTextAreaElement> = this.commentRef.nativeElement.querySelectorAll('textarea');
        inputs[inputs.length - 1]?.focus();
      });
    }
  }

  public deleteComment(event: MouseEvent): void {
    event.stopPropagation();
    this.deleteCommentRequested.emit();
  }

  public handleKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.editFinished.emit();
    }
  }

}
